import { render, staticRenderFns } from "./CompanyLogoUpload.vue?vue&type=template&id=3ed3c62e&scoped=true"
import script from "./CompanyLogoUpload.vue?vue&type=script&lang=js"
export * from "./CompanyLogoUpload.vue?vue&type=script&lang=js"
import style0 from "./CompanyLogoUpload.vue?vue&type=style&index=0&id=3ed3c62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3c62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
